import { render, staticRenderFns } from "./WelcomeFaqAccordion.vue?vue&type=template&id=70c2d3e2&"
import script from "./WelcomeFaqAccordion.vue?vue&type=script&lang=js&"
export * from "./WelcomeFaqAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports